<div class="stepper-wrapper">
  <div class="stepper">
    @for (step of steps(); let i = $index; track step.key) {
      <div class="step">
        <button type="button" class="step__icon-button" (click)="onStepClick(step.key)">
          <div class="step__icon-box" [class.step__icon-box--selected]="isStepSelected(step.key)">
            <svg-icon
              class="step__main-icon"
              [class.step__main-icon--current-stage]="isCurrentProjectStage(step.key)"
              [src]="step.icon"
            />
            @if (isStepChecked(step.key)) {
              <span class="step__checked-badge">
                <svg-icon src="/assets/img/ic-checked-green.svg" />
              </span>
            }
          </div>
          <span class="step__label">{{ step.label }}</span>
        </button>

        @if (i < steps().length - 1) {
          <div class="step__line" [class.step__line--active]="step.status === 'completed'"></div>
        }
      </div>
    }
  </div>
</div>
